import React from "react";
import NotFound from "../components/helpersUI/NotFound";

function PageNotFound() {
  return (
    <div className="flex items-center justify-center min-h-screen text-center bg-gradient-to-r from-saluta-s to-saluta-c">
      <NotFound msg="Página no Encontrada" />
    </div>
  );
}

export default PageNotFound;
